import React from 'react';
import { Checkbox } from 'material-ui';
import './task-list-item.scss'

const TaskListItem = ({name, date}) => {
    return (
        <div className='task-list-item'>
            <p>{name} ({date})</p>
            <Checkbox 
                className="task-checkbox"
            />
        </div>
    );
};

export default TaskListItem;